import { FilterFn } from '@tanstack/react-table';

/**
 * A no-op TanStack Table filter that always passes every row.
 *
 * Use this alongside a pre-filtered `data` array (e.g. from {@link createFuseSearch})
 * when the actual filtering happens in a `useMemo` before data reaches the table.
 * A custom filter is still needed because `table.web.tsx` enables
 * `getFilteredRowModel()` whenever `state.globalFilter` is truthy — without this,
 * TanStack falls back to `includesString` and rejects fuzzy/typo-tolerant matches.
 *
 * @typeParam T - The row data type for the table.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const passThroughFilter: FilterFn<any> = (
  _row,
  _columnId,
  _filterValue,
) => true;

/**
 * Tells TanStack Table to remove the filter when the value is falsy
 * (empty string, null, undefined), restoring the unfiltered table.
 */
passThroughFilter.autoRemove = (val: unknown) => !Boolean(val);
